module.exports = {"title":"Pazar","parts":["Ali elmayı çok severdi. Evde meyve yoktu. Annesi Ali'ye: Haydi pazara gidelim, meyve alalım. dedi. Ali çok sevindi: Elma istiyorum anneciğim. dedi.","Ali ve annesi yürüdüler, pazara gittiler. Pazarda sebze ve meyveler vardı. Ali ve annesi elma, portakal, muz ve limon aldılar. Pazardan çıktılar, sonra eve geldiler.","Annesi meyveleri buzdolabına koydu. Ali hemen dolabı açtı. Bir elma aldı, yıkadı ve yedi. Ali elmayı çok sevdi."],"id":"mo_7"}


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/metinokuma/7.json
// module id = lKuv
// module chunks = 4